import CareerIcon from "./career-icon";

const Status = (data) => {
  const status = data.data;
  const pop = status.population;
  const date = status.created_at.split("T")[0];
  const time = status.created_at.split("T")[1];

  const kills = status.kills;
  if (!kills) {
    return null;
  }

  const xzones = Object.keys(kills).map(function (key) {
    return [key, kills[key]];
  });

  xzones.sort(function (first, second) {
    const first_kills = first[1].order_kills + first[1].destro_kills;
    const second_kills = second[1].order_kills + second[1].destro_kills;
    return second_kills - first_kills;
  });

  const zones = xzones.length > 0 && [xzones[0][0]]; //kills && Object.keys(status.kills);
  if (xzones.length >= 2) {
    zones.push(xzones[1][0]);
  }

  //const zones = kills && Object.keys(xzones);

  if (!zones || zones[0] == "early") {
    return null;
  }

  return (
    <div className="status bg-ror p-2 md:p-5 md:h-60 my-2 md:grid grid-cols-12 gap-5">
      <div className="col-span-2">
        <div className=" justify-between mt-2.5">
          <div>{time.substring(0, 5)}</div>
          <div className="text-xs">{date}</div>
        </div>
        <div className="mt-5 space-y-2">
          <div>T2+ Pop. {pop.population}</div>
          <div className="flex w-full">
            <div className="text-sky-400 font-bold">{pop["order%"]}%</div>
            <div
              className="bg-sky-500 h-4 mt-1 ml-2"
              style={{
                width: pop.order / 15 + "%",
                //backgroundColor: "#f90",
              }}
            ></div>
            <div
              className="bg-red-500 h-4 mt-1 mr-2"
              style={{
                width: pop.destro / 15 + "%",
                //backgroundColor: "#f90",
              }}
            ></div>
            <div className="text-red-400 font-bold">{pop["destro%"]}%</div>
          </div>
        </div>
      </div>
      <div className="col-span-10 md:grid grid-cols-2 mt-10 md:mt-0">
        {zones.slice(0, 2).map((zone) => {
          return (
            <div className="col-span-1 mt-2 mb-8 md:h-12 ">
              <div className="cols-span-12 font-bold">
                {zone}
                {"  "}|{"  "}Total Kills:{" "}
                {kills[zone].order_kills + kills[zone].destro_kills}
              </div>

              <div className="col-span-5 xhidden mt-2">
                <div className="flex">
                  <div className="text-sky-400 w-24">Order Kills:</div>
                  <div className="text-sky-400 w-6">
                    {kills[zone].order_kills}
                  </div>
                  <div
                    className="bg-sky-500 h-2 mt-2 ml-2"
                    style={{
                      width: kills[zone].order_kills / 10 + "%",
                    }}
                  ></div>
                </div>
                <div className="text-xxs text-white space-x-2 min-h-10">
                  {kills[zone].order_guilds &&
                    kills[zone].order_guilds.slice(0, 5).map((guild) => {
                      return (
                        <span>
                          {"<"}
                          {guild[0]}
                          {">"}
                          {guild[1]}
                        </span>
                      );
                    })}
                </div>
                <div className="text-xxs text-white space-x-2 flex h-6 mt-1">
                  {kills[zone].order_careers &&
                    kills[zone].order_careers.slice(0, 6).map((guild) => {
                      return (
                        <>
                          {<CareerIcon career={guild[0]} />} {guild[1]}
                        </>
                      );
                    })}
                </div>
              </div>
              <div className="col-span-5 xhidden md:min-h-10 mt-2">
                <div className="flex">
                  <div className="text-red-400 w-24">Destro Kills:</div>
                  <div className="text-red-400 w-6">
                    {kills[zone].destro_kills}
                  </div>
                  <div
                    className="bg-red-500 h-2 mt-2 ml-2"
                    style={{
                      width: kills[zone].destro_kills / 10 + "%",
                    }}
                  ></div>
                </div>
                <div className="text-xxs text-white space-x-2">
                  {kills[zone].destro_guilds.slice(0, 5).map((guild) => {
                    return (
                      <span>
                        {"<"}
                        {guild[0]}
                        {">"}
                        {guild[1]}
                      </span>
                    );
                  })}
                </div>
                <div className="text-xxs text-white space-x-2 flex h-6 mt-1">
                  {kills[zone].destro_careers &&
                    kills[zone].destro_careers.slice(0, 6).map((guild) => {
                      return (
                        <>
                          {<CareerIcon career={guild[0]} />} {guild[1]}
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Status;
